import React, { useMemo, useState } from 'react';
import { createContext } from '@shared/utils/createContext';

type ContextValue = Readonly<{
  offset: number;
  setOffset: (value: number) => void;
}>;

const NOOP = () => {};
const INITIAL_VALUE: ContextValue = { offset: 0, setOffset: NOOP };

const [ContextProvider, useMobileTopBarNavOffsetContext] = createContext<ContextValue>({
  name: 'AlohaMobileTopBarNavOffset',
  initialValue: INITIAL_VALUE,
  strict: false,
});

type ProviderProps = Readonly<{ children: React.ReactNode }>;

export const AlohaMobileTopBarNavOffsetProvider: React.FC<ProviderProps> = ({ children }) => {
  const [offset, setOffset] = useState(0);
  const value = useMemo(() => ({ offset, setOffset }), [offset]);
  return <ContextProvider value={value}>{children}</ContextProvider>;
};

export const useMobileTopBarNavOffset = () => useMobileTopBarNavOffsetContext().offset;
export const useSetMobileTopBarNavOffset = () => useMobileTopBarNavOffsetContext().setOffset;
